(() => {
  const SEARCH_RESULTS_SELECTOR = '[data-aa-search-results]';
  const SEARCH_ITEM_SELECTOR = '[data-aa-search-item]';
  const PREDICTIVE_ITEM_SELECTOR = '[data-aa-predictive-item]';
  const SEARCH_FORM_SELECTOR = '[data-aa-search-form]';

  const trackedLists = new WeakSet();

  const toNumber = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
  };

  const getSearchTermFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get('q') || '';
  };

  const getCurrency = (item) => (
    item?.dataset.currency
    || document.documentElement.getAttribute('data-cart-currency')
    || window.Shopify?.currency?.active
    || undefined
  );

  const buildListItem = (item) => ({
    item_id: item.dataset.itemId || undefined,
    item_name: item.dataset.itemName || undefined,
    item_category: item.dataset.itemCategory || undefined,
    price: toNumber(item.dataset.itemPrice),
    index: toNumber(item.dataset.itemPosition),
  });

  const sanitizePayload = (payload) => Object.fromEntries(
    Object.entries(payload).filter(([, value]) => (
      value !== undefined
      && value !== null
      && value !== ''
      && !(Array.isArray(value) && value.length === 0)
    ))
  );

  const emitAnalytics = (eventName, payload) => {
    const cleanPayload = sanitizePayload(payload);

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, cleanPayload);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        ...cleanPayload
      });
    }

    document.dispatchEvent(new CustomEvent(`aa:${eventName}`, {
      detail: cleanPayload
    }));
  };

  const trackSearchSubmit = (form) => {
    const input = form.querySelector('input[name="q"]');
    const colorFilter = form.querySelector('input[name="filter.v.option.color"]');
    const query = input?.value?.trim();

    if (!query) return;

    emitAnalytics('search', {
      search_term: query,
      search_source: form.dataset.searchSource || 'unknown',
      color_family_filter: colorFilter?.value || undefined
    });
  };

  const trackResultListView = (container) => {
    if (!container || trackedLists.has(container)) return;

    const items = Array.from(container.querySelectorAll(SEARCH_ITEM_SELECTOR))
      .map(buildListItem)
      .filter((item) => item.item_id || item.item_name);

    trackedLists.add(container);

    if (!items.length) return;

    const firstItem = container.querySelector(SEARCH_ITEM_SELECTOR);

    emitAnalytics('view_item_list', {
      item_list_id: firstItem?.dataset.itemListId || 'search_results',
      item_list_name: firstItem?.dataset.itemListName || 'Search results',
      search_term: container.dataset.searchTerm || getSearchTermFromUrl(),
      items,
      currency: getCurrency(firstItem)
    });
  };

  const trackResultClick = (item) => {
    emitAnalytics('select_item', {
      item_list_id: item.dataset.itemListId || 'search_results',
      item_list_name: item.dataset.itemListName || 'Search results',
      search_term: item.closest(SEARCH_RESULTS_SELECTOR)?.dataset.searchTerm || getSearchTermFromUrl(),
      currency: getCurrency(item),
      items: [buildListItem(item)]
    });
  };

  const trackPredictiveClick = (item) => {
    const searchRoot = item.closest('[data-aa-search-component]');
    const payload = {
      search_term: searchRoot?.querySelector('.js-search-input')?.value?.trim() || getSearchTermFromUrl(),
      search_source: searchRoot?.dataset.searchSource || 'header',
      predictive_type: item.dataset.predictiveType || undefined,
      predictive_index: toNumber(item.dataset.predictiveIndex),
      destination_url: item.dataset.itemUrl || undefined
    };

    if (item.dataset.itemId || item.dataset.itemName) {
      emitAnalytics('select_item', {
        ...payload,
        item_list_id: 'predictive_search',
        item_list_name: 'Predictive search',
        currency: getCurrency(item),
        items: [buildListItem(item)]
      });
      return;
    }

    emitAnalytics('search_suggestion_click', payload);
  };

  const bindSearchForms = () => {
    document.querySelectorAll(SEARCH_FORM_SELECTOR).forEach((form) => {
      if (form.dataset.aaSearchSubmitBound === 'true') return;

      form.dataset.aaSearchSubmitBound = 'true';
      form.addEventListener('submit', () => {
        trackSearchSubmit(form);
      });
    });
  };

  const bindResultClicks = () => {
    document.querySelectorAll(SEARCH_ITEM_SELECTOR).forEach((item) => {
      if (item.dataset.aaSearchClickBound === 'true') return;

      item.dataset.aaSearchClickBound = 'true';
      item.addEventListener('click', (event) => {
        if (!event.target.closest('a, button')) return;
        trackResultClick(item);
      });
    });
  };

  const bindPredictiveClicks = () => {
    document.querySelectorAll(PREDICTIVE_ITEM_SELECTOR).forEach((item) => {
      if (item.dataset.aaPredictiveClickBound === 'true') return;

      item.dataset.aaPredictiveClickBound = 'true';
      item.addEventListener('click', (event) => {
        if (!event.target.closest('a, button')) return;
        trackPredictiveClick(item);
      });
    });
  };

  const init = () => {
    bindSearchForms();
    bindResultClicks();
    bindPredictiveClicks();

    document.querySelectorAll(SEARCH_RESULTS_SELECTOR).forEach(trackResultListView);
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('on:facet-filters:updated', init);
})();
